<template>
    <b-modal :active.sync="show" id="productreturnmodal" aria-modal :width="600" :can-cancel="false">
        <div class="modal-card" style="width: auto">
            <b-loading :active.sync="loading" :is-full-page="false"></b-loading>

            <header class="modal-card-head"><p class="modal-card-title">Product terugnemen</p></header>
            <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                <p>Wie komt het product ({{ product.name }}) terugbrengen?</p>

                <b-field label="Klant">
                    <b-select placeholder="Selecteer de klant" v-model="selectedCustomer" :disabled="loading" :loading="loading" expanded>
                        <option v-for="(customer, index) in customers" :value="index" :key="'customer_'+index">
                            <span v-if="customer.contract?.customer">
                                {{ customer.contract.customer.firstname }}&nbsp;{{ customer.contract.customer.lastname }}&nbsp;(Contract #{{ customer.contract.id }} - Startdatum: {{ moment(customer.contract.start_date).format('DD-MM-Y') }})
                            </span>
                            <span v-else>
                                Onbekende klant
                            </span>
                        </option>
                    </b-select>
                </b-field>

                <div v-show="amount > 1">
                    <br>

                    <b-field label="Hoeveel producten worden ingeleverd?">
                        <b-numberinput v-model="returned" min="1" :max="amount"></b-numberinput>
                    </b-field>
                </div>
            </section>
            <footer class="modal-card-foot text-right">
                <button class="button" type="button" @click="$emit('closeProductReturnModal')">Annuleren</button>
                <button class="button is-success" @click="confirm">Bevestigen</button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import toastMixins from '@/mixins/toastMixins.js'

export default {
    name: 'ProductReturnModal',

    mixins: [toastMixins],

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            product: {},
            selectedCustomer: null,
            customers: {},
            amount: 1,
            returned: 1,
        }
    },

    methods: {
        fetchContractWhereProduct(product){
            // Reset
            this.amount = 1
            this.returned = 1

            this.loading = true
            this.product = product
            this.selectedCustomer = null
            this.customers = {}

            axios.get('/api/products/'+this.product.id+'/contractproducts', {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.customers = response.data.filter(customer => customer.contract?.customer)
                this.selectedCustomer = 0
            }).catch((error) => {
                console.error(error)
                this.showError('Daar gaat iets fout! Probeer het opnieuw!')
                this.$emit('closeProductReturnModal')
            }).then(() => {
                this.loading = false
            })
        },

        confirm(){
            this.loading = true

            axios.post('/api/products/'+this.product.id+'/contractproducts/'+this.customers[this.selectedCustomer].id, {
                'id': this.customers[this.selectedCustomer].id,
                'amount': this.returned
            }, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(response.data == 'success'){
                    this.showMessage('Succesvol ingeleverd!')
                    this.$emit('reload')
                    this.$emit('closeProductReturnModal')
                } else {
                    throw new Error()
                }
            }).catch(() => {
                this.showError('Daar gaat iets fout! Probeer het opnieuw!')
                this.$emit('closeProductReturnModal')
            }).then(() => {
                this.loading = false
            })
        }
    },

    watch: {
        selectedCustomer(newVal){
            if(!_.isNull(newVal)){
                this.amount = this.customers[newVal].to_return
                this.returned = 1
            } else {
                this.amount = 1
            }
        }
    }
}
</script>
